<template>
  <div
    ref="editorialContainer"
    class="enhanced-editorialText"
    :class="{
      backgroundColorApplayed:
        (!resultcard.desktopBackgroundImageUrl && !smallScreen) ||
        (!resultcard.mobileBackgroundImageUrl && smallScreen),
      [resultcard.contentAlignment.value + '-main']: !!resultcard.contentAlignment.value,
    }"
    :style="
      resultcard.componentBackgroundColor
        ? { '--comp-bg-color': resultcard.componentBackgroundColor }
        : {}
    "
  >
    <div ref="editorialInnerContainer" class="enhanced-editorialText-innerWrapper">
      <div
        v-if="
          (resultcard.desktopBackgroundImageUrl && !smallScreen) ||
          (resultcard.mobileBackgroundImageUrl && smallScreen)
        "
        ref="bannerBgImage"
        class="enhanced__bg-image"
      >
        <picture>
          <source
            :data-srcset="resultcard.mobileBackgroundImageUrl"
            media="(max-width:1023px)"
            :srcset="transparentPixel"
          />
          <img
            ref="bannerImage"
            class="lazyload"
            :data-src="resultcard.desktopBackgroundImageUrl"
            :alt="
              smallScreen
                ? resultcard.mobileBackgroundImageAlt
                : resultcard.desktopBackgroundImageAlt
            "
            :src="transparentPixel"
          />
        </picture>
      </div>
      <div
        ref="mainContent"
        class="enhanced__mainContent-container"
        :class="resultcard.contentAlignment.value"
      >
        <div class="content-wrapper">
          <div class="content-details">
            <div
              v-if="resultcard.preTitle"
              class="content__preTitle"
              :style="
                resultcard.preTitleColour
                  ? { '--comp-preTitleColour-color': resultcard.preTitleColour }
                  : {}
              "
            >
              {{ resultcard.preTitle }}
            </div>
            <h2
              v-if="resultcard.title"
              class="content__title"
              :style="
                resultcard.titleColour ? { '--comp-titleColour-color': resultcard.titleColour } : {}
              "
            >
              {{ resultcard.title }}
            </h2>
            <div
              v-if="resultcard.description"
              class="content__description"
              v-html="resultcard.description"
            ></div>
            <a
              v-if="resultcard.ctaText && resultcard.ctaPosition.value === 'BelowDescription'"
              :href="resultcard.ctaLink"
              target="_blank"
              :class="resultcard.ctaType.value"
              :style="{
                ...(resultcard.ctacolour ? { '--comp-ctacolour-color': resultcard.ctacolour } : {}),
                ...(resultcard.ctaTextColour
                  ? { '--comp-ctaTextColour-color': resultcard.ctaTextColour }
                  : {}),
              }"
              @click="triggerTagging(resultcard.ctaTaggingAttributes)"
              >{{ resultcard.ctaText }}
            </a>
          </div>
          <enhanced-editorial-threecard
            v-if="!smallScreen && resultcard.imageCardContent"
            :data="resultcard"
          ></enhanced-editorial-threecard>
          <a
            v-if="
              !smallScreen &&
              resultcard.ctaText &&
              resultcard.ctaPosition.value === 'BelowThreeImages'
            "
            :href="resultcard.ctaLink"
            target="_blank"
            :class="resultcard.ctaType.value"
            :style="{
              ...(resultcard.ctacolour ? { '--comp-ctacolour-color': resultcard.ctacolour } : {}),
              ...(resultcard.ctaTextColour
                ? { '--comp-ctaTextColour-color': resultcard.ctaTextColour }
                : {}),
            }"
            @click="triggerTagging(resultcard.ctaTaggingAttributes)"
            >{{ resultcard.ctaText }}</a
          >
        </div>
      </div>
    </div>
    <!--smallScreen-->
    <enhanced-editorial-threecard
      v-if="smallScreen && resultcard.imageCardContent"
      :data="resultcard"
    ></enhanced-editorial-threecard>
    <div
      v-if="
        smallScreen && resultcard.ctaText && resultcard.ctaPosition.value === 'BelowThreeImages'
      "
      class="belowThreeImages"
    >
      <a
        :href="resultcard.ctaLink"
        :class="resultcard.ctaType.value"
        :style="{
          ...(resultcard.ctacolour ? { '--comp-ctacolour-color': resultcard.ctacolour } : {}),
          ...(resultcard.ctaTextColour
            ? { '--comp-ctaTextColour-color': resultcard.ctaTextColour }
            : {}),
        }"
        @click="triggerTagging(resultcard.ctaTaggingAttributes)"
        >{{ resultcard.ctaText }}</a
      >
    </div>
    <!--smallScreen-->
  </div>
</template>
<script>
import enhancedEditorialThreecard from './enhanced-editorial-threeCard.vue';

export default {
  name: 'enhanced-editorial-text',
  components: {
    enhancedEditorialThreecard,
  },
  props: {
    resultcard: {
      type: [Object, Array],
      default: () => [],
    },
  },
  data() {
    return {
      smallScreen: window.matchMedia('(max-width: 1023px)').matches,
      bgImageAvailable: false,
      transparentPixel:
        'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    };
  },
  mounted() {
    const card = this.$refs.editorialContainer;
    const image = this.$refs.bannerImage;
    const content = this.$refs.mainContent.querySelector('.content-wrapper');
    if (!this.smallScreen) {
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Start loading the image
              image.src = image.dataset.src;

              // Stop observing
              observer.unobserve(card);

              // Wait for image to fully load
              image.addEventListener('load', () => {
                this.$nextTick(() => {
                  const imageHeight = image.getBoundingClientRect().height;
                  const contentHeight = content.getBoundingClientRect().height;
                  if (imageHeight < contentHeight) {
                    this.$refs.editorialContainer.style.aspectRatio = `${window.innerWidth} / ${contentHeight + 100}`;
                    this.$refs.editorialInnerContainer.style.aspectRatio = `${window.innerWidth} / ${contentHeight + 100}`;
                  }
                });
              });
            }
          });
        },
        {
          threshold: 0.1,
        },
      );

      this.observer.observe(card);
    }
  },
  methods: {
    toValidJsonString(str) {
      const htmlDecoded = str.replace(/&#39;/g, "'");
      const quoteKeys = htmlDecoded.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');
      const doubleQuoted = quoteKeys.replace(/'/g, '"');
      return doubleQuoted;
    },
    triggerTagging(rawData) {
      if (rawData) {
        const jsonStr = this.toValidJsonString(rawData);
        const data = JSON.parse(jsonStr);
        try {
          dataLayer.push(data);
        } catch {
          console.warn(data);
        }
      }
    },
  },
};
</script>
